module.exports = __webpack_public_path__ + "img/sentio-logo.3f9f71d4.svg";